// src/context/ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // Dark mode toggle UI is currently hidden across the app, so we force everyone
    // to 'light' by default. This also migrates existing users who previously had
    // 'dark' saved in localStorage, so they don't get stuck in dark mode with no
    // way to switch back now that the toggle is hidden.
    // Original logic (restore when dark mode UI is re-enabled):
    // const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme && savedTheme !== 'light') {
            localStorage.setItem('theme', 'light');
        }
        return 'light';
    });

    // Toggle between dark and light themes
    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    // Save theme preference to localStorage and update the document class
    useEffect(() => {
        localStorage.setItem('theme', theme);
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

// Custom hook to use the theme context
export const useTheme = () => useContext(ThemeContext);